import css from './deckPanel.module.scss';

import { memo } from 'react';

import { getDeckUrl, getExerciseUrl } from 'core/paths';
import ExerciseLabel from 'core/ui/ExerciseLabel';
import { ListPanel } from 'core/ui/ListPanel';
import ICONS from 'core/ui/icons';

import MenuBody from './MenuBody';
import PendingLabel from './PendingLabel';

type TProps = {
  deck: TDeckRich;
  reload: () => Promise<void>;
};

export default memo(function DeckPanel({ deck, reload }: TProps) {
  return (
    <ListPanel
      body={{
        type: 'containerPanel',
        title: deck.name,
        total: deck.wordsCount,
        pending: deck.pendingWordsCount,
        itemsLabel: 'Cards',
      }}
      actionsWidth="11rem"
      actions={[
        ...deck.exercises.map(exercise => [
          {
            disabled: !deck.status[exercise]?.count,
            link: getExerciseUrl(deck.uid, exercise),
            label: (
              <ExerciseActionLabel
                exercise={exercise}
                deck={deck}
                info={orDie(deck.status[exercise])}
              />
            ),
            colSpan: 2 as const,
          },
        ]),
        [
          {
            link: getDeckUrl(deck.uid),
            title: 'Show cards',
            icon: ICONS.Cards,
          },
          {
            icon: ICONS.Menu,
            title: 'Show menu',
            menuItems: <MenuBody deck={deck} reload={reload} />,
          },
        ],
      ]}
    />
  );
});

type TExerciseActionLabelProps = {
  exercise: TExercise;
  deck: TDeck;
  info: { count: number; closest: string | null };
};
const ExerciseActionLabel = ({
  exercise,
  info,
  deck,
}: TExerciseActionLabelProps) => (
  <div className={css.exeActionLabel}>
    <ExerciseLabel
      className={css.exeLabel}
      exercise={exercise}
      deckLang={deck.lang}
    />
    {info.count > 0 && (
      <span className={css.exeWordsCount}>+{info.count}w</span>
    )}
    {!info.count && info.closest && <PendingLabel date={info.closest} />}
  </div>
);
